import { ReactNode, memo, useEffect } from 'react';
import { I18nextProvider } from 'react-i18next';

import i18n from './i18n';

type TranslationProviderProps = {
  children: ReactNode;
  language: string;
  translationContent: { [key: string]: unknown };
  onMissingKey?: ({
    language,
    translationKey,
  }: {
    language: string[];
    translationKey: string;
  }) => void;
};

interface MissingKeyHandler {
  (language: string[], namespace: string, key: string): void;
}

export const TranslationProvider = memo(function TranslationProvider({
  children,
  language,
  translationContent,
  onMissingKey,
}: TranslationProviderProps) {
  useEffect(
    function registerLanguageContent() {
      i18n.addResourceBundle(language, 'translation', translationContent);
      i18n.changeLanguage(language);
    },
    [language, translationContent]
  );

  useEffect(
    function registerTranslationEvents() {
      const missingKeyHandler: MissingKeyHandler = (language, namespace, translationKey) => {
        console.warn(`[Translation]: Missing translation key: ${translationKey}`);

        onMissingKey?.({ language, translationKey });
      };

      i18n.on('missingKey', missingKeyHandler);

      return () => {
        i18n.off('missingKey', missingKeyHandler);
      };
    },
    [onMissingKey]
  );

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
});
